import { render, staticRenderFns } from "./BlacklistInfo.vue?vue&type=template&id=589fa6ce&scoped=true&"
import script from "./BlacklistInfo.vue?vue&type=script&lang=js&"
export * from "./BlacklistInfo.vue?vue&type=script&lang=js&"
import style0 from "./BlacklistInfo.vue?vue&type=style&index=0&id=589fa6ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589fa6ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VCard,VCol,VRow})
